<template>
  <div id="product">
    <div class="header flex-between">
      <div class="header-text">
        <h1>礼券报表</h1>
      </div>

      <div class="header-button">
        <el-button v-if="jurisdiction.search" icon="el-icon-notebook-2" @click="SelectdisplayitemDialog = true">选择显示项</el-button>
        <el-button icon="el-icon-notebook-2" @click="conditionDialog = true">展开隐藏条件</el-button>
        <el-button icon="el-icon-search" v-if="jurisdiction.search" @click="search()">查询</el-button>
        <el-button icon="el-icon-delete" @click="eliminate()">清除筛选条件</el-button>
        <el-button icon="iconfont icon-chakan1" v-if="jurisdiction.export" @click="exportShow = true">导出</el-button>
        <el-button icon="el-icon-download" v-if="jurisdiction.export" @click="(downloadShow = true), getDownladList()">下载</el-button>
      </div>
    </div>
    <!-- 表单 -->
    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form label-width="120px" :model="queryInfo" size="small" :inline="true">
          <el-form-item label="礼券名称">
            <el-input v-model="queryInfo.CouponsName"></el-input>
          </el-form-item>

          <el-form-item label="券库编号">
            <el-input v-model="queryInfo.coupGrpNo"></el-input>
          </el-form-item>

          <el-form-item label="礼券状态">
            <el-select style="width: 100%" v-model="queryInfo.State">
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="有效"></el-option>
              <el-option value="1" label="已核销"></el-option>
              <el-option value="2" label="已禁用"></el-option>
              <el-option value="3" label="未发放"></el-option>
              <el-option value="4" label="无效"></el-option>
              <el-option value="5" label="已过期"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="礼券类型">
            <el-select style="width: 100%" v-model="queryInfo.CouponsKind">
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="现金券"></el-option>
              <el-option value="1" label="折扣劵"></el-option>
              <el-option value="2" label="礼品劵"></el-option>
              <el-option value="3" label="异业劵"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="礼品名称">
            <el-input v-model="queryInfo.GiftName"></el-input>
          </el-form-item>
          <el-form-item label="礼品编号">
            <el-input v-model="queryInfo.GiftNo"></el-input>
          </el-form-item>
          <el-form-item label="礼品类型">
            <el-select style="width: 100%" v-model="queryInfo.GiftKind">
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="成衣"></el-option>
              <el-option value="1" label="鞋履"></el-option>
              <el-option value="2" label="配饰"></el-option>
              <el-option value="3" label="非公司商品"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form :model="queryInfo" size="small" :inline="true" label-position="left">
          <el-form-item label="总记录数">
            <el-input readonly :value="total ? toThousands(total) : ''"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <el-table
          :key="key"
          height="430px"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in formThead" :key="index" :label="item.titleName" :prop="item.fieldName"></el-table-column>
          <!-- <el-table-column label="礼券编号" prop="CoupCode"></el-table-column>
          <el-table-column
            label="礼券名称"
            prop="CouponsName"
          ></el-table-column>

          <el-table-column
            label="礼券后台名称"
            prop="InnerCoupName"
          ></el-table-column>

          <el-table-column label="券类型" prop="CouponsKind">
            <template slot-scope="scope">
              {{
                scope.row.CouponsKind == 0
                  ? "现金券"
                  : scope.row.CouponsKind == 1
                  ? "折扣券"
                  : scope.row.CouponsKind == 2
                  ? "礼品券"
                  : scope.row.CouponsKind == 3
                  ? "异业券"
                  : ""
              }}
            </template>
          </el-table-column>

          <el-table-column label="券值" prop="CoupValue"></el-table-column>

          <el-table-column label="礼品名称" prop="GiftName"></el-table-column>

          <el-table-column label="礼品编号" prop="GiftNo"></el-table-column>

          <el-table-column label="礼品类型" prop="GiftKind">
            <template slot-scope="scope">
              {{
                scope.row.GiftKind == 0
                  ? "成衣"
                  : scope.row.GiftKind == 1
                  ? "鞋履"
                  : scope.row.GiftKind == 2
                  ? "配饰"
                  : scope.row.GiftKind == 3
                  ? "非公司商品"
                  : ""
              }}
            </template>
          </el-table-column>

          <el-table-column label="所有人" prop="">
            <template slot-scope="scope">
              {{ scope.row.LastName }}{{ scope.row.FirstName }}
            </template>
          </el-table-column>

          <el-table-column label="所有人卡号" prop="CardNo"></el-table-column>

          <el-table-column label="发放方式" prop="ReleaseMode">
            <template slot-scope="scope">
              {{
                scope.row.ReleaseMode == 0
                  ? "营销发券"
                  : scope.row.ReleaseMode == 1
                  ? "积分兑换"
                  : scope.row.ReleaseMode == 2
                  ? "扫码领券"
                  : ""
              }}
            </template>
          </el-table-column>

          <el-table-column label="发放方式" prop="ReleaseMode">
            <template slot-scope="scope">
              {{
                scope.row.ReleaseMode == 0
                  ? "营销发券"
                  : scope.row.ReleaseMode == 1
                  ? "积分兑换"
                  : scope.row.ReleaseMode == 2
                  ? "扫码领券"
                  : ""
              }}
            </template>
          </el-table-column>

          <el-table-column label="有效期开始时间" prop="StartDate">
            <template slot-scope="scope">
              <div v-if="scope.row.StartDate">
                {{ scope.row.StartDate | dateFormats }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="有效期结束时间" prop="EndDate">
            <template slot-scope="scope">
              <div v-if="scope.row.EndDate">
                {{ scope.row.EndDate | dateFormats }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="核销方式" prop="VeriMode">
            <template slot-scope="scope">
              {{
                scope.row.VeriMode == 1
                  ? "销售核销"
                  : scope.row.VeriMode == 2
                  ? "领取核销"
                  : scope.row.VeriMode == 3
                  ? "手工核销"
                  : ""
              }}
            </template>
          </el-table-column>

          <el-table-column label="销售单号" prop="SaleNo"></el-table-column>

          <el-table-column label="领取单号" prop="RecvNo"></el-table-column>

          <el-table-column label="状态" prop="State">
            <template slot-scope="scope">
              {{
                scope.row.State == 0
                  ? "有效"
                  : scope.row.State == 1
                  ? "已核销"
                  : scope.row.State == 2
                  ? "已禁用"
                  : scope.row.State == 3
                  ? "未发放"
                  : scope.row.State == 4
                  ? "无效"
                  : ""
              }}
            </template>
          </el-table-column> -->
        </el-table>
        <el-alert v-if="tableData.length >= total" title="没有更多数据了!" type="warning" center :closable="false"></el-alert>
      </el-card>
    </div>
    <!-- 筛选条件弹窗 -->
    <el-dialog append-to-body width="1200px" :visible.sync="conditionDialog" :close-on-click-modal="false">
      <el-row>
        <el-col :span="12">
          <el-form :model="queryInfo" size="small" :inline="true" label-width="120px">
            <el-form-item label="礼券名称">
              <el-input v-model="queryInfo.CouponsName"></el-input>
            </el-form-item>
            <el-form-item label="券库编号">
              <el-input v-model="queryInfo.coupGrpNo"></el-input>
            </el-form-item>
            <el-form-item label="礼券状态">
              <el-select style="width: 100%" v-model="queryInfo.State">
                <el-option value="" label="全部"></el-option>
                <el-option value="0" label="有效"></el-option>
                <el-option value="1" label="已核销"></el-option>
                <el-option value="2" label="已禁用"></el-option>
                <el-option value="3" label="未发放"></el-option>
                <el-option value="4" label="无效"></el-option>
                <el-option value="5" label="已过期"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="礼券类型">
              <el-select style="width: 100%" v-model="queryInfo.CouponsKind">
                <el-option value="" label="全部"></el-option>
                <el-option value="0" label="现金券"></el-option>
                <el-option value="1" label="折扣"></el-option>
                <el-option value="2" label="礼品劵"></el-option>
                <el-option value="3" label="异业劵"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="礼品名称">
              <el-input v-model="queryInfo.GiftName"></el-input>
            </el-form-item>
            <el-form-item label="礼品编号">
              <el-input v-model="queryInfo.GiftNo"></el-input>
            </el-form-item>
            <el-form-item label="礼品类型">
              <el-select style="width: 100%" v-model="queryInfo.GiftKind">
                <el-option value="" label="所有"></el-option>
                <el-option value="0" label="成衣"></el-option>
                <el-option value="1" label="鞋履"></el-option>
                <el-option value="2" label="配饰"></el-option>
                <el-option value="3" label="非公司商品"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="礼券金额">
              <div class="flex-between">
                <el-input style="width: 45%" v-model="queryInfo.CoupValueMin"></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">至</span>
                <el-input style="width: 45%" v-model="queryInfo.CoupValueMax"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="礼券开始时间">
              <el-date-picker
                v-model="dateValue1"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="礼券到期时间">
              <el-date-picker
                v-model="dateValue2"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form :model="queryInfo" size="small" :inline="true" label-width="120px">
            <el-form-item label="使用时间">
              <el-date-picker
                v-model="dateValue3"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="发放时间">
              <el-date-picker
                v-model="dateValue4"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="核销方式">
              <el-select v-model="queryInfo.VeriMode">
                <el-option value="" label="全部"></el-option>
                <el-option value="1" label="销售核销"></el-option>
                <el-option value="2" label="领取核销"></el-option>
                <el-option value="3" label="手工核销"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="券发放方式">
              <el-select v-model="queryInfo.ReleaseMode">
                <el-option value="" label="全部"></el-option>
                <el-option value="0" label="营销发券"></el-option>
                <el-option value="1" label="积分兑换"></el-option>
                <el-option value="2" label="扫码领劵"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="礼券编号">
              <el-input v-model="queryInfo.CoupCode"></el-input>
            </el-form-item>
            <el-form-item label="礼券所有人">
              <el-input v-model="queryInfo.BelongCust"></el-input>
            </el-form-item>
            <el-form-item label="礼券所有人维护区域">
              <el-select v-model="queryInfo.regionId" placeholder="请选择">
                <el-option label="所有" value=""> </el-option>
                <el-option v-for="item in Regioncax" :key="item.id" :label="item.lable" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="礼券所有人维护门店">
              <el-col :span="16">
                <textarea rows="8" v-model="searchData.mechanismStr" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button style="margin-left: 10px" @click="(outletVisible = true), (shopId = queryInfo.shopIds)">选择门店</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="title">
        <div class="dialogTitle">
          <span>条件</span>
          <div></div>
          <div>
            <el-button @click="search()">查 询</el-button>
            <el-button @click="eliminate()">清除查询条件</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 门店弹窗 -->
    <el-dialog append-to-body width="30%" :visible.sync="outletVisible" title="选择门店">
      <el-form size="mini" label-width="90px">
        <el-row :gutter="50" v-for="(item, index) in StoreSelectionList" :key="index">
          <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
            <el-tree
              ref="tree"
              v-if="myitem != undefined"
              :data="[myitem]"
              show-checkbox
              node-key="ShopID"
              highlight-current
              default-expand-all
              :default-checked-keys="shopId"
              :props="defaultProps"
            >
            </el-tree>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ComButtomStore">确 定</el-button>
        <el-button @click="outletVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 下载弹窗 -->
    <el-dialog append-to-body width="50%" :visible.sync="downloadShow" title="下载文件">
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column prop="startTime" label="开始执行时间"></el-table-column>
        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>
        <el-table-column prop="fileName" label="文件名"></el-table-column>
        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button icon="el-icon-download" v-if="scope.row.isComplate" @click="download(scope.row.downloadUrl)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog :close-on-click-modal="false" width="20%" title="导出礼券报表" :visible.sync="exportShow">
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i class="iconfont icon-jingshi" style="font-size: 28px; color: #f39b21"></i>
            是否确定
            <span style="color: #ff0000">导出</span>礼券报表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择显示列弹窗 -->
    <div>
      <el-dialog :close-on-click-modal="false" width="40%" title="显示项" :visible.sync="SelectdisplayitemDialog">
        <el-row :gutter="20">
          <el-col v-for="(item, index) in Selectdisplayitem" :key="index" :span="6">
            <el-checkbox-group @change="handleCheckedCitiesChange" v-model="Selectdisplayiteme">
              <el-checkbox :label="item.ID">{{ item.titleName }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectfinish">选择完成</el-button>
          <el-button @click="Restoredefault">恢复默认选项</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { shopQueryRegionApi } from "@/api/marketing";
import { getcouponListDetail, reportFormList, couponListDetailExport, ReportgetdisplayfiledApi } from "@/api/reportForm";
import { regionalQuery } from "@/api/huiyuanyy"; //区域

export default {
  name: "centre",
  data() {
    return {
      Selectdisplayitem: [],
      Selectdisplayiteme: [],
      SelectdisplayitemDialog: false,
      exportShow: false,
      outletVisible: false, //门店弹窗
      StoreSelectionList: [], //选择门店数据
      conditionDialog: false,
      dateValue: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 50,
        displayFiled: [],
        CouponsName: "",
        coupGrpNo: "",
        State: "",
        CouponsKind: "",
        GiftName: "",
        GiftNo: "",
        GiftKind: "",
        RegistDateStart: "",
        VeriMode: "", //核销方式,
        ReleaseMode: "", //券发放方式,
        CoupCode: "", //礼券编号
        BelongCust: "", //礼券所有人
        regionId: "", // 礼券所有人维护区域
        CoupValueMin: "", //礼券金额开始
        CoupValueMax: "", //礼券金额 结束
        StartDateMin: "", //礼券开始时间
        StartDateMax: "", //礼券结束时间
        EndDateMin: "", //礼券到期开始时间
        EndDateMax: "", //礼券到期结束时间
        ManualVeriTimeMin: "", //使用开始时间
        ManualVeriTimeMax: "", //使用结束时间
        ReleaseTimeMin: "", //发放开始时间
        ReleaseTimeMax: "", //发放结束时间
        shopIds: [],
      },
      bodyStyle: {
        padding: "0px",
      },
      loading: true,
      StoreSelectLength: 0,
      StoredataArray: [],
      shopId: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      searchData: {
        mechanismStr: "", //升级vic机构数据
        mechanismId: [], //升级vic机构id
      },
      dateValue1: [], //注册日期
      dateValue2: [], //生日
      dateValue3: [], //最近购买日
      dateValue4: [], //升级为VIC的时间

      Regioncax: [], //区域
      jurisdiction: {
        search: false,
        export: false,
      },
      total: 0,
      lock: false,
      downloadData: [],
      downloadShow: false,
      //
      formThead: [],
      key: "",
      ID1: "",
    };
  },
  computed: {
    onLoading() {
      return this.loading || this.tableData.length >= this.total;
    },
  },
  created() {
    this.Reportgetdisplayfiled();
    // this.tableList();
    this.regioNalinformation();
    let GiftCertificateReportForm = JSON.parse(localStorage.getItem("GiftCertificateReportForm"));
    this.ShopqueryRegionList();
    for (let i = 0; i < GiftCertificateReportForm.length; i++) {
      if (GiftCertificateReportForm[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (GiftCertificateReportForm[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
  },
  methods: {
    // 选择完成
    Selectfinish() {
      this.queryInfo.displayFiled = this.ID1;
      this.tableData = [];
      this.queryInfo.pageNum = 1;
      this.tableList();
      this.loading = true;
      this.formThead = this.Selectdisplayitem.filter((i) => this.ID1.indexOf(i.ID) >= 0);
      this.key = this.key + 1;
      this.SelectdisplayitemDialog = false;
    },
    // 恢复默认选项
    Restoredefault() {
      this.Selectdisplayiteme = [];
      this.Reportgetdisplayfiled();
      this.tableData = [];
      this.queryInfo.pageNum = 1;
      console.log("恢复", this.queryInfo.displayFiled);
      this.loading = true;
      this.$message.success("恢复默认选项成功!");
      this.SelectdisplayitemDialog = false;
    },
    // 显示项checkbox点击获值
    handleCheckedCitiesChange(val) {
      // this.formThead = this.Selectdisplayitem.filter(
      //   (i) => val.indexOf(i.ID) >= 0
      // );
      // this.key = this.key + 1
      this.ID1 = val;
      console.log(val);
    },
    // 获取显示项
    Reportgetdisplayfiled() {
      ReportgetdisplayfiledApi({ reportId: 1001 }).then((res) => {
        if (res.success == true) {
          this.formThead = [];
          this.key = this.key + 1;
          this.Selectdisplayitem = res.data;
          // 判断是否默认选项
          this.Selectdisplayitem.forEach((item) => {
            if (item.IsDefault == true) {
              this.Selectdisplayiteme.push(item.ID);
              this.ID1 = this.Selectdisplayiteme;
              this.queryInfo.displayFiled = this.Selectdisplayiteme;
              console.log(this.queryInfo.displayFiled);
              this.formThead.push(item);
            }
          });
          this.tableList();
        }
        console.log("显示项", this.Selectdisplayitem);
      });
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "礼券",
      }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    //每三位数字加，
    toThousands(num) {
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    },
    //导出
    Export() {
      let data = {
        displayFiled: this.queryInfo.displayFiled,
        CouponsName: this.queryInfo.CouponsName,
        coupGrpNo: this.queryInfo.coupGrpNo,
        State: this.queryInfo.State, //状态
        CouponsKind: this.queryInfo.CouponsKind, //礼券类型
        GiftName: this.queryInfo.GiftName, //礼品名称
        GiftNo: this.queryInfo.GiftNo, //'礼品编号',
        GiftKind: this.queryInfo.GiftKind, //礼品类型
        StartDateMin: this.queryInfo.StartDateMin, //礼券开始时间
        StartDateMax: this.queryInfo.StartDateMax, //礼券结束时间
        EndDateMin: this.queryInfo.EndDateMin, //礼券到期开始时间
        EndDateMax: this.queryInfo.EndDateMax, //礼券到期结束时间
        ManualVeriTimeMin: this.queryInfo.ManualVeriTimeMin, //使用开始时间
        ManualVeriTimeMax: this.queryInfo.ManualVeriTimeMax, //使用结束时间
        ReleaseTimeMin: this.queryInfo.ReleaseTimeMin, //发放开始时间
        ReleaseTimeMax: this.queryInfo.ReleaseTimeMax, //发放结束时间
        VeriMode: this.queryInfo.VeriMode, //核销方式,
        ReleaseMode: this.queryInfo.ReleaseMode, //券发放方式,
        CoupCode: this.queryInfo.CoupCode, //礼券编号
        BelongCust: this.queryInfo.BelongCust, //礼券所有人
        regionId: this.queryInfo.regionId, // 礼券所有人维护区域
        CoupValueMin: this.queryInfo.CoupValueMin, //礼券金额开始
        CoupValueMax: this.queryInfo.CoupValueMax, //礼券金额 结束
        shopIds: this.queryInfo.shopIds,
      }; //列表页搜索数据

      couponListDetailExport(data).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看");
      });
    },
    eliminate() {
      this.queryInfo = {
        pageNum: 1,
        pageSize: 20,
        displayFiled: this.queryInfo.displayFiled,
        CouponsName: "",
        coupGrpNo: "",
        State: "",
        CouponsKind: "",
        GiftName: "",
        GiftNo: "",
        GiftKind: "",
        RegistDateStart: "",
        VeriMode: "", //核销方式,
        ReleaseMode: "", //券发放方式,
        CoupCode: "", //礼券编号
        BelongCust: "", //礼券所有人
        regionId: "", // 礼券所有人维护区域
        CoupValueMin: "", //礼券金额开始
        CoupValueMax: "", //礼券金额 结束
        StartDateMin: "", //礼券开始时间
        StartDateMax: "", //礼券结束时间
        EndDateMin: "", //礼券到期开始时间
        EndDateMax: "", //礼券到期结束时间
        ManualVeriTimeMin: "", //使用开始时间
        ManualVeriTimeMax: "", //使用结束时间
        ReleaseTimeMin: "", //发放开始时间
        ReleaseTimeMax: "", //发放结束时间
        shopIds: [],
      };
      this.searchData.mechanismStr = "";
      this.loading = true;
      this.tableData = [];
      this.dateValue1 = []; //注册日期
      this.dateValue2 = []; //生日
      this.dateValue3 = []; //最近购买日
      this.dateValue4 = []; //升级为VIC的时间
      this.conditionDialog = false;
      this.tableList();
    },
    search() {
      if (this.lock) {
        return;
      }
      //礼券开始时间
      if (this.dateValue1 && this.dateValue1.length > 0) {
        this.queryInfo.StartDateMin = this.renderTime(this.dateValue1[0]).substring(0, 10);
        this.queryInfo.StartDateMax = this.renderTime(this.dateValue1[1]).substring(0, 10);
      } else {
        this.queryInfo.StartDateMin = "";
        this.queryInfo.StartDateMax = "";
      }
      //礼券到期时间
      if (this.dateValue2 && this.dateValue2.length > 0) {
        this.queryInfo.EndDateMin = this.renderTime(this.dateValue2[0]).substring(0, 10);
        this.queryInfo.EndDateMax = this.renderTime(this.dateValue2[1]).substring(0, 10);
      } else {
        this.queryInfo.EndDateMin = "";
        this.queryInfo.EndDateMax = "";
      }

      //使用时间
      if (this.dateValue3 && this.dateValue3.length > 0) {
        this.queryInfo.ManualVeriTimeMin = this.renderTime(this.dateValue3[0]).substring(0, 10);
        this.queryInfo.ManualVeriTimeMax = this.renderTime(this.dateValue3[1]).substring(0, 10);
      } else {
        this.queryInfo.ManualVeriTimeMin = "";
        this.queryInfo.ManualVeriTimeMax = "";
      }
      //发放时间
      if (this.dateValue4 && this.dateValue4.length > 0) {
        this.queryInfo.ReleaseTimeMin = this.renderTime(this.dateValue4[0]).substring(0, 10);
        this.queryInfo.ReleaseTimeMax = this.renderTime(this.dateValue4[1]).substring(0, 10);
      } else {
        this.queryInfo.ReleaseTimeMin = "";
        this.queryInfo.ReleaseTimeMax = "";
      }
      this.lock = true;
      this.queryInfo.pageNum = 1;
      this.tableData = [];
      this.loading = true;
      this.conditionDialog = false;
      this.tableList();
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    //区域渲染数据
    async regioNalinformation() {
      const res = await regionalQuery({ regionID: "" });
      this.Regioncax = res.data;
    },
    //统计
    load() {
      this.loading = true;
      this.queryInfo.pageNum += 1;
      this.tableList();
    },
    // 获取区域门店
    ShopqueryRegionList() {
      shopQueryRegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [key, arr2[value]]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      let listOfSomeStoresl = [];
      let listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          listOfSomeStoresl.push(...this.StoredataArray[index].chlidren);
        } else {
          listOfSomeStoresl.push(...item);
        }
      }
      listOfSomeStoresl.forEach((item) => {
        listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // listOfSomeStoreslStr = listOfSomeStoreslStr.substring(
      //   0,
      //   listOfSomeStoreslStr.length - 2
      // );
      let shopId = []; //选中门店数据
      for (let i = 0; i < listOfSomeStoresl.length; i++) {
        shopId.push(listOfSomeStoresl[i].id);
      }

      this.searchData.mechanismStr = listOfSomeStoreslStr;
      this.queryInfo.shopIds = shopId;
      this.outletVisible = false;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    tableList() {
      getcouponListDetail(this.queryInfo).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            item.CouponsKind =
              item.CouponsKind == 0
                ? "现金券"
                : item.CouponsKind == 1
                ? "折扣券"
                : item.CouponsKind == 2
                ? "礼品券"
                : item.CouponsKind == 3
                ? "异业券"
                : "";
            item.GiftKind =
              item.GiftKind == 0 ? "成衣" : item.GiftKind == 1 ? "鞋履" : item.GiftKind == 2 ? "配饰" : item.GiftKind == 3 ? "非公司商品" : "";
            item.ReleaseMode = item.ReleaseMode == 0 ? "营销发券" : item.ReleaseMode == 1 ? "积分兑换" : item.ReleaseMode == 2 ? "扫码领券" : "";
            item.StartDate = this.renderTime(item.StartDate);
            item.EndDate = this.renderTime(item.EndDate);
            item.VeriMode = item.VeriMode == 1 ? "销售核销" : item.VeriMode == 2 ? "领取核销" : item.VeriMode == 3 ? "手工核销" : "";
            item.State =
              item.State == 0
                ? "有效"
                : item.State == 1
                ? "已核销"
                : item.State == 2
                ? "已禁用"
                : item.State == 3
                ? "未发放"
                : item.State == 4
                ? "无效"
                : item.State == 5
                ? "已过期"
                : "";
          });
        }
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        setTimeout(() => {
          this.loading = false;
          this.lock = false;
        }, 200);
      });
    },
    Seachbtn() {
      // let cuarItem = {
      //   CouponsName: this.queryInfo.CouponsName,
      //   State: this.queryInfo.State, //状态
      //   CouponsKind: this.queryInfo.CouponsKind, //礼券类型
      //   GiftName: this.queryInfo.GiftName, //礼品名称
      //   GiftNo: this.queryInfo.GiftNo, //'礼品编号',
      //   GiftKind: this.queryInfo.GiftKind, //礼品类型
      //   StartDateMin: "", //礼券开始时间
      //   StartDateMax: "", //礼券结束时间
      //   EndDateMin: "", //礼券到期开始时间
      //   EndDateMax: "", //礼券到期结束时间
      //   ManualVeriTimeMin: "", //使用开始时间
      //   ManualVeriTimeMax: "", //使用结束时间
      //   ReleaseTimeMin: "", //发放开始时间
      //   ReleaseTimeMax: "", //发放结束时间
      //   VeriMode: this.queryInfo.VeriMode, //核销方式,
      //   ReleaseMode: this.queryInfo.ReleaseMode, //券发放方式,
      //   CoupCode: this.queryInfo.CoupCode, //礼券编号
      //   BelongCust: this.queryInfo.BelongCust, //礼券所有人
      //   regionId: this.queryInfo.regionId, // 礼券所有人维护区域
      //   CoupValueMin: this.queryInfo.CoupValueMin, //礼券金额开始
      //   CoupValueMax: this.queryInfo.CoupValueMax, //礼券金额 结束
      //   shopIds: this.queryInfo.shopIds,
      // };
      // console.log(cuarItem);
    },
  },
};
</script>
<style lang="scss" scoped>
#product {
  height: 100%;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.buttonInfo {
  display: flex;
  justify-content: space-between;
  margin: 10px 100px;
}
.buttonInfo > div {
  display: flex;
  width: 35%;
}
.buttonInfo > div > div:first-child {
  margin-right: 10px;
}
.header {
  .header-text {
    width: 300px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
.xuan .el-button {
  color: #4d4d4d;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
.dialogTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
}
.dialogTitle > span {
  font-size: 16px;
  font-weight: 700;
  color: #6c6937;
}
</style>
